import { loPublicSitePath } from '@/lib/lyrraone-custom-domain';
import type { LoPublicFormationCard } from '@/lib/lyrraone-public';

export function isExternalUrl(url: string): boolean {
  return /^https?:\/\//i.test(url) || url.startsWith('mailto:') || url.startsWith('tel:');
}

/** Réécrit les liens catalogue global vers le store du créateur sur son site. */
export function resolveLoSiteLink(
  siteSlug: string,
  url: string | undefined,
  customDomainSlug?: string | null,
): string {
  if (!url?.trim()) return '#';
  const trimmed = url.trim();
  if (isExternalUrl(trimmed)) return trimmed;
  if (trimmed === '#formations') {
    return loPublicSitePath(siteSlug, { formations: true }, customDomainSlug);
  }
  if (trimmed === '#boutique' || trimmed === '#products') {
    return loPublicSitePath(siteSlug, { boutique: true }, customDomainSlug);
  }
  if (trimmed === '/store' || trimmed === '/store/') {
    return loPublicSitePath(siteSlug, { formations: true }, customDomainSlug);
  }
  const storeDetail = trimmed.match(/^\/store\/([^/?#]+)/);
  if (storeDetail) {
    return loPublicSitePath(
      siteSlug,
      { formations: true, formationId: decodeURIComponent(storeDetail[1]) },
      customDomainSlug,
    );
  }
  return trimmed;
}

export function creatorFormationHref(
  formation: LoPublicFormationCard,
  siteSlug: string,
  customDomainSlug?: string | null,
  lang?: string,
): string {
  if (formation.funnelSlug) {
    return `/f/${encodeURIComponent(formation.funnelSlug)}`;
  }
  return loPublicSitePath(
    siteSlug,
    { formations: true, formationId: formation.id, ...(lang ? { lang } : {}) },
    customDomainSlug,
  );
}

export function creatorPhysicalProductHref(
  product: LoPublicPhysicalProductCard,
  siteSlug: string,
  customDomainSlug?: string | null,
  lang?: string,
): string {
  if (product.funnelSlug) {
    return `/f/${encodeURIComponent(product.funnelSlug)}/checkout`;
  }
  return loPublicSitePath(
    siteSlug,
    { boutique: true, productId: product.id, ...(lang ? { lang } : {}) },
    customDomainSlug,
  );
}
